import { ProductVariationMetadataDtoMap } from '@libs/mtjr/shared/generated/dtoMaps/product-variation-metadata.dto.map';
import { VariationAttributeDtoMap } from '@libs/mtjr/shared/generated/dtoMaps/variation-attribute.dto.map';
import { Expose, Type } from 'class-transformer';

export class ProductVariationDtoMap {
  @Expose()
  id!: string;

  @Expose()
  image?: string;

  @Expose()
  price!: number;

  @Expose()
  discount?: number;

  @Expose()
  stock!: number;

  @Type(() => VariationAttributeDtoMap)
  @Expose()
  attributes!: VariationAttributeDtoMap[];

  @Type(() => ProductVariationMetadataDtoMap)
  @Expose()
  metadata?: ProductVariationMetadataDtoMap;
}
